import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { LicensesType } from '@/core/infra';
import { getDiscount } from '../../helper';
import AmplitudeSendEvent from '../../src/hooks/useAmplitude';
import { useLocalStorage } from '../../src/hooks/useLocalStorage';
import Icon from '../common/Icon';
import Spinner from '../common/Spinner';
import { useContextState } from '../context';
import DetailedLicenses from '../DetailedLicenses/DetailedLicenses';
import { getPrices } from './service';
import { Subscription } from './Subscription';

const BODY = [2, 3];

export const ToLogin = ({ t }) => (
  <Link href={{ pathname: '/terminal/login' }} passHref>
    <span className="btn btn-grey">
      <span>{t('prices_info_buy')}</span>
    </span>
  </Link>
);

interface ToBuyProps {
  t: any;
  type: LicensesType;
  name: string;
  priceId?: string;
  value?: string;
  setAffiseInfoToStorage?: (name: any, value: any) => void;
}

export const ToBuy: React.FC<ToBuyProps> = ({ t, type, name, priceId }) => {
  const router = useRouter();
  const {
    i18n: { language },
  } = useTranslation();

  const confirmBuyingLicense = () => {
    // if (language !== 'en' && language !== 'ua') {
    router.push(
      `/terminal/confirm-buying-license/${type.toLowerCase()}${
        priceId ? '?priceId=' + priceId : ''
      }`
    );
    // } else {
    //   notificationShowAction({ text: t('not-able-to-pay-now'), color: 'red' });
    // }
  };

  const {
    user: { email },
  } = useContextState();

  return (
    <div
      className="btn-wrap"
      onClick={() => AmplitudeSendEvent({ event_type: `Buy ${name}`, email })}
    >
      <button type="button" className="btn btn-grey" onClick={confirmBuyingLicense}>
        <span>{t('prices_info_buy')}</span>
      </button>
    </div>
  );
};

const Prices = ({}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { set } = useLocalStorage();
  const [swiper, setThumbsSwiper] = useState<any>(null);
  const [swiper2, setSwiper] = useState<any>(null);
  const [allPrices, setAllPrices] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const {
    isMobileDevice,
    authorized,
    user: { email },
  } = useContextState();
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(1);
  const slideTo = (event, index) => {
    event.stopPropagation();
    if (swiper) {
      setCurrentSlide(index);
      swiper.slideTo(index, 1, false);
      swiper2.slideTo(index, 1, false);
    }
  };

  const stockPrices = useMemo(
    () =>
      allPrices?.filter(
        (price) => price.type === LicensesType.STOCK_MARKET && price.name !== 'TigerX6'
      ),
    [allPrices]
  );

  const playerPrices = useMemo(
    () => allPrices?.filter((price) => price.type === LicensesType.PLAYER),
    [allPrices]
  );

  const setAffiseInfoToStorage = (name, value) => {
    set('purchaseId', name);
    set('purchaseSum', value);
  };

  useEffect(() => {
    if (!allPrices) {
      setIsLoading(true);
      getPrices().then((prices) => {
        setAllPrices(prices);
        setIsLoading(false);
      });
    }
  }, [language, allPrices]);

  const downloadLink = {
    onClick: () => {
      AmplitudeSendEvent({ event_type: `Buy Crypto`, email });
      AmplitudeSendEvent({ event_type: `Download`, email });
    },
  };

  return isLoading ? (
    <Spinner />
  ) : (
    <div className="content">
      {/* <BlackFriday isInternalPage={true} /> */}
      <div className="prices">
        <div className="big-title">
          <div className="title-wrap">
            <h1>{t('prices_welcome')}</h1>
            <a href={'#compare'} className="detail-link">
              {t('prices_compare_licenses')}{' '}
              <Icon width={1.5} height={1.5} file="sprite" name="arrow-down" />
            </a>
          </div>
          <div className="text">
            <ul>
              <li>
                <Icon width="30" height="30" file="sprite" name="30-success" />
                {t('prices_welcome_chapter1')}
              </li>
              <li>
                <Icon width="30" height="30" file="sprite" name="30-success" />
                {t('prices_welcome_chapter2')}
              </li>
            </ul>
          </div>
        </div>
        <div className="grid">
          <div className="l">
            <div className="plan">
              <div className="grid-title">
                <span>{t('prices_crypto_type')}</span>
              </div>
              <div className="text">
                <div className="time">{t('prices_welcome_price_tab1_header')}</div>
                <div className="price">
                  <div className="big green">{t('prices_welcome_price_tab1_amount')}</div>
                </div>
                <ul>
                  <li>
                    <Icon width="30" height="30" file="sprite" name="30-success" />
                    {t('prices_welcome_price_tab1_body')}
                  </li>
                </ul>
              </div>
              <Link href="/terminal/download" {...downloadLink} passHref>
                <span className="btn btn-grey" id="3939">
                  <span>{t('prices_welcome_price_tab1_link')}</span>
                </span>
              </Link>
            </div>
          </div>
          <div className="r-info">{t('prices_welcome_price_tab2_footer')}</div>
          <Subscription
            allPrices={stockPrices}
            authorized={authorized}
            BODY={BODY}
            currentSlide={currentSlide}
            slideTo={slideTo}
            isMobileDevice={isMobileDevice}
            navigationNextRef={navigationNextRef}
            navigationPrevRef={navigationPrevRef}
            setAffiseInfoToStorage={setAffiseInfoToStorage}
            setSwiper={setSwiper}
            setThumbsSwiper={setThumbsSwiper}
            ToBuy={ToBuy}
            swiper={swiper}
            wrapperClassName="r"
            textLicenseBuy={null}
            priceLicenseBuy={null}
            ulPriceLicenseBuy={null}
            setNewLicense={() => null}
          />
          <div className="r-info">{t('prices_welcome_price_tab1_footer')}</div>
        </div>
        <div className="grid grid-player">
          <div className="l">
            <div className="plan">
              <div className="price-text">
                <div className="price">
                  <div className="player-title">{t('prices_history_player')}</div>
                  <div className="player-info">
                    <span>{t('prices_history_player_description')}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="l-info" />
          <div className="r">
            <div className="thumbs thumbs-player">
              {playerPrices.map(({ currency, id, name, value, discount }) => (
                <div className="plan plan-player" key={id}>
                  <div className="text">
                    <div className="time">{t('prices_welcome_price_tab_player_label')}</div>
                    <div className="price-ul-wrap">
                      <div className="price">
                        <div className="big">
                          <sup>{currency}</sup>
                          {new Intl.NumberFormat('ru-RU').format(value)}
                          {!!discount && (
                            <del>
                              <span>
                                {getDiscount(value, discount).formattedPrice}
                                {currency}
                              </span>
                            </del>
                          )}
                        </div>
                        <div className="period">{t('prices_welcome_price_tab_player_label')}</div>
                        {/* <div className="small">{description}</div>*/}
                        {!!discount && (
                          <div className="small">
                            {t('price_saving')} {currency}
                            {new Intl.NumberFormat('ru-RU').format(discount)}
                          </div>
                        )}
                      </div>
                      <ul>
                        <li>
                          <Icon width="30" height="30" file="sprite" name="30-success" />
                          {t(`licenceInfo6`)}
                        </li>
                        <li>
                          <Icon width="30" height="30" file="sprite" name="30-success" />
                          {t(`licenceInfo7`)}
                        </li>
                      </ul>
                    </div>
                  </div>
                  {authorized ? (
                    <ToBuy
                      type={LicensesType.PLAYER}
                      setAffiseInfoToStorage={setAffiseInfoToStorage}
                      value={value}
                      name={name}
                      t={t}
                    />
                  ) : (
                    <ToLogin t={t} />
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="r-player-info">
            <span>{t('prices_history_player_description')}</span>{' '}
          </div>

          {/*<div id="detailed" className="r-info-detailed">*/}
          {/*  {t('prices_welcome_price_tab_player_footer')}*/}
          {/*</div>*/}
        </div>
        <DetailedLicenses />
      </div>

      <div
        className="big-text"
        onClick={() => {
          AmplitudeSendEvent({ event_type: `Download`, email });
        }}
      >
        <Link href="/terminal/download" passHref>
          <span className="big-text-download">{t('prices_download_now')} </span>
        </Link>
        {t('prices_download_now_text')}
      </div>
      {/*<div className="buyers-information-container">*/}
      {/*  <InformationForBuyers />*/}
      {/*</div>*/}
    </div>
  );
};

export default Prices;
